export const GRADE_TYPE_LABELS = {
  freeform: 'Free form',
  percentage: 'Percentages',
  rubric: 'Rubric',
  passFail: 'Pass/Fail',
};

export const STATUS_TOOLTIPS = {
  upcoming:
    'This assignment block is visible to students but they cannot access it until the open date.',
  open: 'The assignment is open for submissions.',
  nearDueDate: 'The assignment is open for submissions.',
  pastDueDate:
    'The due date is past but the assignment is still open for submissions.',
  closed:
    'The assignment is closed and does not accept submissions at this point.',
  submitted: 'Submitted',
  submittedLate: 'Submitted Late',
  notSubmitted: 'Not Submitted',
  manualAssignment: 'This is a manually graded assignment.',
};
